import dataUtils from '@/utils/api/dataUtils';

const PREFIX = '/user/auth';

/**
 * 사용자 로그인 API
 *
 * @param {Object} data
 * @param {string} data.loginId
 * @param {string} data.password
 *
 * @returns {AxiosResponse} response
 */
export const login = async (data) => {
  return await dataUtils.postData(`/v1${PREFIX}/sign-in`, data);
};

/**
 * 토큰 업데이트 API
 *
 *
 * @returns {AxiosResponse} response
 */
export const getRefreshToken = async (data) => {
  return await dataUtils.postData(`/v1${PREFIX}/refresh`, data, {
    'Content-Type': 'application/json',
    'Refresh-Header': 'refresh'
  });
};
